import reducers from "./reducers";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "../services/api";

const rootReducer = combineReducers({
  ...reducers,
  [api.reducerPath]: api.reducer,
});

export const setupStore = (preloadedState) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
    preloadedState,
  });

  setupListeners(store.dispatch);
  return store;
};
